import { render, staticRenderFns } from "./IlfordCity.vue?vue&type=template&id=67919cea&scoped=true&"
import script from "./IlfordCity.vue?vue&type=script&lang=js&"
export * from "./IlfordCity.vue?vue&type=script&lang=js&"
import style0 from "./IlfordCity.vue?vue&type=style&index=0&id=67919cea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67919cea",
  null
  
)

export default component.exports